import createDataContext from './createDataContext';
import * as actions from './actions/documentActions';
import { reducer, initialState } from './reducers/documentReducer';

export const { Context: DocumentContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
